<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
      >
        <task-container-view
          :employee-uid="employee.employee_uid"
          :is-profile-tab="false"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      TaskContainerView: () => import('@/components/task/ContainerView'),
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
  }
</script>
